// WO-33 — Mid2Bid Brand Guidelines v9 §07, as Tailwind classes.
// Primary: Growth Green #217922 (dark mode #3BB34A), white text, one per view.
// Secondary: transparent, Navy #0F2D4E text, 1 px border.
// Radius 6 px · padding 10×20 px · Inter SemiBold 14 px · min height 40 px
// desktop / 48 px mobile · hover 10% darker · visible focus outline.
const base =
  'inline-flex items-center justify-center gap-2 rounded-[6px] px-5 py-[10px] text-sm font-semibold ' +
  'min-h-[48px] sm:min-h-[40px] transition-colors duration-150 ease-in-out ' +
  'focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#217922] ' +
  'disabled:opacity-50 disabled:cursor-not-allowed';

export const btnPrimary =
  `${base} bg-[#217922] text-white hover:bg-[#1E6D1F] dark:bg-[#3BB34A] dark:hover:bg-[#35A143] dark:text-white`;

export const btnSecondary =
  `${base} bg-transparent border border-[#0F2D4E] text-[#0F2D4E] hover:bg-[#0F2D4E]/10 ` +
  'dark:border-white/60 dark:text-white dark:hover:bg-white/10';

export const panel =
  'bg-white dark:bg-card border border-[#E2E8F0] dark:border-border rounded-lg ' +
  'shadow-[0_1px_3px_rgba(0,0,0,.08)]';

export const fontStyle = { fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" };
